var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketsLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 123,
    viewBox: "0 0 166 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.876 29.0444C149.818 28.7028 150.305 27.662 149.964 26.7166L144.29 10.9381C141.903 4.30415 134.61 0.868 128.001 3.26337L69.1905 24.5754L10.384 45.8915C3.77522 48.2868 0.352093 55.608 2.73839 62.242L8.41325 78.0204C8.75359 78.9659 9.79042 79.4545 10.7323 79.1128C14.8638 77.6152 19.4227 79.7643 20.9146 83.9115C22.4065 88.0587 20.2656 92.635 16.1341 94.1326C15.1922 94.4742 14.7055 95.515 15.0458 96.4604L20.7207 112.239C23.107 118.873 30.4004 122.309 37.0092 119.914L95.8197 98.6016L154.63 77.2895C161.239 74.8941 164.662 67.5729 162.276 60.939L156.601 45.1605C156.261 44.2151 155.224 43.7265 154.282 44.0681C150.15 45.5657 145.592 43.4166 144.1 39.2694C142.608 35.1222 144.749 30.546 148.88 29.0484L148.876 29.0444Z",
    fill: "#00C1D5",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.272 50.6107C120.64 43.2935 114.103 38.5305 106.873 37.8195C105.832 37.7162 105.052 38.7609 105.404 39.7461L111.883 57.7571C112.152 58.5039 111.764 59.3301 111.02 59.6003L101.866 62.9172C101.122 63.1874 100.299 62.7981 100.03 62.0512L93.552 44.0403C93.1959 43.0551 91.9335 42.7532 91.1974 43.5C86.0845 48.6801 84.086 56.5415 86.7176 63.8547C89.373 71.2315 95.9977 76.0183 103.303 76.6618C103.845 76.7095 104.308 77.0789 104.498 77.5914L109.916 92.055C110.189 92.7978 111.008 93.1792 111.748 92.909L122.904 88.8651C123.656 88.595 124.04 87.7608 123.763 87.01L118.357 72.5861C118.163 72.0657 118.282 71.4738 118.673 71.0806C123.873 65.9005 125.919 57.9755 123.268 50.6067L123.272 50.6107Z",
    fill: "#00C1D5",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3069 34.6852L68.2012 108.858",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5076 56.4263L33.8274 49.3673",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1897 37.9068L123.114 16.7457",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5942 100.794L49.9181 93.7352",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0134 110.221L46.1111 105.8",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsLogo);
export default __webpack_public_path__ + "static/media/Tickets_logo.e03fc89b657d54e7cebd853037dd6a5f.svg";
export { ForwardRef as ReactComponent };